import React from "react";
import PrivacyPolicy from "../Components/PrivacyPolicy";

function Privacy() {
  return <PrivacyPolicy />;
}

export default Privacy;
